import {Component, computed, inject, input, linkedSignal, model, output} from '@angular/core';
import {SecteurActiviteService} from '../../../core/services/entities/secteur-activite.service';
import {SecteurActiviteDTO} from '../../../core/dtos/secteur-activite-dto';
import {ToastService} from '../../../core/services/technique/toast.service';
import {Auth2Service} from '../../../core/services/security/auth2.service';
import {SiteDTO} from '../../../core/dtos/site-dto';
import {MSG_KEY, MSG_SEVERITY} from '../../../core/constants';
import {ButtonThemeEnum} from '../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-secteur-activite-dialog',
  templateUrl: './secteur-activite-dialog.component.html',
  styleUrls: ['./secteur-activite-dialog.component.scss'],
  standalone: false
})
export class SecteurActiviteDialogComponent {

  protected readonly ButtonThemeEnum = ButtonThemeEnum;

  private readonly secteurActiviteSvc = inject(SecteurActiviteService);
  private readonly toastSvc = inject(ToastService);
  private readonly auth2Svc = inject(Auth2Service);

  readonly displayDialog = model<boolean>(false);
  readonly dto = input<SecteurActiviteDTO | null>(null);
  readonly saved = output<{ dto: SecteurActiviteDTO; isUpdate: boolean }>();

  readonly dialogTitle = computed(() => this.dto()?.id
    ? 'Modification d\'un secteur d\'activité'
    : 'Création d\'un secteur d\'activité'
  );

  readonly formData = linkedSignal(() => {
    const dto = this.dto();
    return {id: dto?.id ?? 0, libelle: dto?.libelle ?? '', code: dto?.code ?? '', actif: dto?.actif ?? true, site: dto?.site ?? null};
  });

  readonly isFormValid = computed(() => {
    const d = this.formData();
    return !!d.site?.id
      && !!d.libelle?.trim() && d.libelle.length <= 100
      && !!d.code?.trim() && d.code.length <= 30;
  });

  findAllLocalSites = (): SiteDTO[] => this.auth2Svc.utilisateur.siteListLocaux;

  closeDialog = (): void => this.displayDialog.set(false);

  onChangeSite = ($event: any): void => {
    this.formData.update(s => ({...s, site: $event.selectedItem as SiteDTO}));
  };

  onChangeLibelle = ($event: any): void => {
    this.formData.update(s => ({...s, libelle: $event.value}));
  };

  onChangeCode = ($event: any): void => {
    this.formData.update(s => ({...s, code: $event.value}));
  };

  onChangeActif = ($event: any): void => {
    this.formData.update(s => ({...s, actif: $event.value}));
  };

  save = (): void => {
    if (!this.isFormValid()) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, 'Veuillez compléter le formulaire');
      return;
    }

    const payload = this.formData();
    const isUpdate = payload.id !== null && payload.id !== undefined && payload.id !== 0;

    this.secteurActiviteSvc.save(payload).subscribe(response => {
      this.saved.emit({dto: response.one, isUpdate});
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, 'Sauvegarde du secteur d\'activité réalisée avec succès');
      this.closeDialog();
    });
  };
}
